import React, { FC } from "react";
import { useIsDesktop } from "repoV2/utils/common/render/screen";
import Slide from "@mui/material/Slide";
import { IModalTypes } from "./IModal";
import DesktopModal from "./DesktopModal";
import MobileModal from "./MobileModal";

const Modal: FC<IModalTypes.ModalProps> = ({ children, ...rest }) => {
    const isDesktop = useIsDesktop();

    const ModalComponent = isDesktop ? DesktopModal : MobileModal;

    const { open } = rest;

    return (
        <ModalComponent {...rest}>
            <Slide direction="up" in={open} mountOnEnter unmountOnExit>
                {children}
            </Slide>
        </ModalComponent>
    );
};

export default Modal;

/*
Implementation looks like this:

 <Modal open={isOpen} onClose={onClose}>
    <ModalContent>
        <ModalHeader
            showCloseIcon
            onClose={onClose}
        >
        Header Title
        </ModalHeader>
        <ModalBody>
            <p>hello</p>
        </ModalBody>
        <ModalFooter>
            <ButtonV2
                onClick={() => console.log("inside on click handler")}
            >
                click
            </ButtonV2>
        </ModalFooter>
    </ModalContent>
</Modal>
*/
